import { Button, Stack } from '@mui/material';
import { PlusCircleIcon } from '@phosphor-icons/react';
import { useId } from 'react';

import { FormField } from 'common';

import { BlockTextArrayItemField } from './ItemField';
import { useReactFlowViewContext } from '../../../../context/context';
import { useSelectedNodeField } from '../../useSelectedNodeField';

interface BlockTextArrayFieldProps {
  label: string;
  addRowLabel: string;
  fieldName: string;
  placeholder: string;
}

export function BlockTextArrayField(props: BlockTextArrayFieldProps) {
  const { label, addRowLabel, fieldName, placeholder } = props;
  const {
    value: values = [],
    setValue: setValues,
    visibleError,
  } = useSelectedNodeField<string[]>(fieldName);
  const { isEditable } = useReactFlowViewContext();
  const id = useId();

  return (
    <Stack gap={1}>
      <FormField id={id} error={visibleError} label={label}>
        <Stack gap={1}>
          {values.map((value, index) => {
            return (
              <BlockTextArrayItemField
                key={index}
                fieldName={`${fieldName}.${index}`}
                placeholder={placeholder}
                onDelete={() => {
                  setValues(values.filter((item) => item !== value));
                }}
              />
            );
          })}
        </Stack>
      </FormField>
      {isEditable && (
        <Button
          variant="text"
          sx={{
            alignSelf: 'start',
            gap: 0.5,
          }}
          onClick={() => {
            setValues([...(values ?? []), '']);
          }}
        >
          <PlusCircleIcon size={24} />
          {addRowLabel}
        </Button>
      )}
    </Stack>
  );
}
